import Header from "./Header";
import "../App.css";
import "./homepage.css";

export default function HomePage() {
  return (
    <>
      <Header />
      <div className="homepage"></div>
    </>
  );
}
